export const GLOBAL_STATE = 'Level'

export const LEVEL_ALL = 'LEVEL_ALL' as const
